import React, { useState, useContext } from "react";
import { FirebaseContext } from "./Firebase";
import { useNavigate } from "react-router-dom";
import "../css/Login.css";
import spryte from "./images/white-spryte.png";

const UpdatePassword = () => {
  const firebase = useContext(FirebaseContext);
  const history = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (!password || !confirmPassword) {
      setError("Please fill in all fields");
      setIsLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      setIsLoading(false);
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters long");
      setIsLoading(false);
      return;
    }

    try {
      await firebase.doPasswordUpdate(password);
      const userId = firebase.auth.currentUser.uid;
      const userRef = firebase.db.collection("users").doc(userId);
      const accountRef = userRef.collection("accounts").doc("spryte-partner");

      await accountRef.set({ passwordUpdated: true }, { merge: true });

      // After password update, reload the page to refresh session data and log them into their vendor account
      window.location.href = "/";
    } catch (err) {
      setError(err.message || "Failed to update password. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div className="login-div">
      <div className="login">
        <div className="login-left">
          <div
            className="spryte-ctr"
            style={{ display: "flex", alignItems: "center" }}
          >
            <h2 className="spryte">spryte labs</h2>
            <div className="spryte-circle">
              <img src={spryte} alt="spryte logo" />
            </div>
          </div>
          <div className="circle">
            <img
              src="https://shellsoftware.net/wp-content/uploads/2020/06/shell_hwid_spoofer_pro.png"
              alt="img"
            />
          </div>
          <div className="login-div">
            <h1>Update Your Password</h1>
            <div className="input-div">
              <p>New Password</p>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your new password"
              />
              <p>Confirm Password</p>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm your new password"
              />
              <div className="button-div">
                {isLoading ? (
                  <div className="loading-ctr">
                    <div className="pulse-container">
                      <div className="pulse-bubble pulse-bubble-1"></div>
                      <div className="pulse-bubble pulse-bubble-2"></div>
                      <div className="pulse-bubble pulse-bubble-3"></div>
                    </div>
                  </div>
                ) : (
                  <a
                    className="login-btn"
                    href="/"
                    onClick={handlePasswordUpdate}
                  >
                    Update Password
                  </a>
                )}
              </div>
            </div>
            <br />
            <p className="error">{error}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
